<template>
<div>
    <div class="get-started w50 p-5">
        <div class="w100">
            <h1>Get<br>started</h1>
            <p class="mt-3">The purpose of the online grocery store (kriyana.com) is to sell the products to the customer for their ease and automate the existing system so that the problems during managing the details of customers, stock, products can be easily figure out. Selling the products online will give benefit to the seller as well as customer. </p>
        </div>
    </div>
    <div class="registration-form-ec">
        <div class="form-wrap form-control-wrapper row align-items-center">

            <a class="back-btn"></a>
            <div class="bg_white form-box">
                <!-- <StoreModal @modalSucess="onModalSuccess" v-model="modalOpen"></StoreModal> -->
                <div class="login-head center">
                    <img src="../../assets/images/kriyana.png" style="width:200px">
                    <!-- <h2>Login</h2> -->
                </div>

                <form id="login" class=" w100 mt-2 form_wrapper_login" autocomplete="off">

                    <label for="mobile">Mobile No.</label>
                    <input type="number" name="mobile" v-model="mobile" class="w100" tabindex="1" id="mobile" required maxlength="10" minlength="10" />
                    
                    <div class="mt-4">
                        <!-- <input type="button" value="Login" @click="submitLogin()" id="submitLogin" class="text-center form-btn"> -->
                        <button  @click="submitLogin()" id="submitLogin" class="text-center form-btn" style="padding:1rem;">Login</button>
                    </div>
                    
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import ApiList from '../ApiList'
export default {
    components: {},
    name: 'Login',
    mixins: [ApiList],
    data() {
        return {
            mobile: '',
            name: '',
            store: '',
            inValidMobile: false,
        }
    },
    watch: {
        mobile() {
            if (this.store.length == 0) {
                if (this.mobile.length == 10) {
                    this.validateMobile()
                }
                if(this.mobile>10)
                {
                    this.mobile = this.mobile.substring(0,10)
                }
                
            }
            
        },
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            localStorage.setItem("loginStatus", false);
            this.customer_id = localStorage.getItem("customer_id")
            this.choose_store();
        },
        async validateMobile() {
            var mb = this.mobile
            this.newUrl = this.apis.apiUrl + this.apis.validateUserMobile;
            this.param = {
                params: {
                    token: this.apis.token,
                    db: this.store,
                    mobile: mb,
                }
            }
            await axios.get(this.newUrl, this.param)
                .then((response) => {
                    console.log(JSON.stringify(response.data))
                    this.inValidMobile = response.data.invalid_mobile
                    //alert("done"+this.validMobile)
                })
                // localStorage.setItem('token',this.apis.token);
        },

        choose_store() {
            let uri = window.location.href.split('?');
            console.log(uri);
            if (uri[1] != undefined) {
                let newUriDet = uri[1].split('_');
                // uriParam  = uri[2];
                console.log(newUriDet[0]);
                this.store = atob(newUriDet[0]);
                if (newUriDet[1] != undefined)
                    localStorage.setItem("referral_code", newUriDet[1]);
                // console.log(uri[1]+' -- '+this.store)
                this.newUrl = this.apis.apiUrl + this.apis.chooseStoreUrl;
                this.param = {
                    params: {
                        token: this.apis.token,
                        db: this.store,
                    }
                }
                axios.get(this.newUrl, this.param)
                    .then((response) => {
                        console.log(response)
                        if (response.data.store_id != '' && response.data.store_name != '') {
                            localStorage.setItem('store_name', response.data.store_name);
                            localStorage.setItem('selected_db', this.store);
                            localStorage.setItem('store_id', response.data.store_id);
                            localStorage.setItem('token', response.data.token);
                        }
                    });
            }
        },
        submitLogin() {
            // console.log(this.mobile);
            // console.log(this.name);
            if(localStorage.tmp_mobile!=this.mobile && localStorage.tmp_mobile!=null )
            {
                localStorage.clear()
            }
            
            if (this.mobile > 6000000000 && this.mobile < 9999999999) {
                localStorage.setItem("tmp_mobile", this.mobile);
                localStorage.setItem("invalidMobile", this.inValidMobile)
                localStorage.setItem("tmp_name", this.name);
                var myToken=""
                if(localStorage.getItem("token") === null)
                {
                    this.newUrl = this.apis.apiUrl + this.apis.validateUserMobile;
                    myToken=this.apis.token
                }
                else{
                    this.newUrl = this.apis.apiUrl + this.apis.sendOtpUrl;
                    myToken = localStorage.token
                }
               this.param = {
                    params: {
                        token: myToken,
                        mobile: this.mobile,
                    }
                }
                axios.get(this.newUrl, this.param)
                    .then((response) => {
                        console.log(response)
                    });
                this.$router.push('/otp')
            } else {
                alert("Invalid Mobile Number");
            }
        },
    },
}
</script>
